<mat-form-field [appearance]="appearance" class="ff-compact">
  <mat-label>{{ label }}</mat-label>

  <input
    #hostInput
    type="text"
    matInput
    [formControl]="displayCtrl"
    [matAutocomplete]="auto"
    (blur)="onTouched()"
    [placeholder]="placeholder"
    [attr.autocomplete]="autocompleteAttr"
  />

  <button *ngIf="value" mat-icon-button matSuffix type="button" class="clear-btn" aria-label="Effacer la sélection" (click)="clearSelection($event)">
    ×
  </button>

  <mat-autocomplete
    #auto="matAutocomplete"
    (opened)="focusSearchBox()"
    (closed)="resetSearch()"
    (optionSelected)="onOptionSelected($event)"
    [autoActiveFirstOption]="autoActiveFirstOption"
  >
    <!-- Barre de recherche dans le panel (non sélectionnable) -->
    <mat-option class="search-option" [value]="null" [tabindex]="-1" aria-disabled="true" (onSelectionChange)="$event.source.deselect?.()">
      <div
        class="search-hitbox"
        (mousedown)="focusSearchBox(); $event.stopPropagation()"
        (touchstart)="focusSearchBox(); $event.stopPropagation()"
        (click)="$event.stopPropagation()"
      >
        <input
          #panelSearch
          type="text"
          class="search-input"
          placeholder="Search..."
          [formControl]="panelSearchCtrl"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
          inputmode="search"
          enterkeyhint="search"
          (mouseup)="$event.preventDefault()"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
          (keydown.enter)="$event.preventDefault()"
        />
      </div>
    </mat-option>

    <mat-option *ngFor="let a of filtered()" [value]="a">
      {{ optionLabel(a) }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
